/**
 * require npm 包的方式
 */
// registerDep('vue', () => require('vue'))
// registerDep('vuex', () => require('vuex'))
// registerDep('vue-router', () => require('vue-router'))
// registerDep('@unicloud/element-ui', () => require('@unicloud/element-ui'))    // 为了使用华三修改的版本1.4.12，直接拷贝element-ui目录
registerDep('@unicloud/element-ui', () => require('@unicloud/element-ui'))    // 为了使用华三修改的版本1.4.12，直接拷贝element-ui目录
registerDep('underscore', () => require('underscore'))

/**
 * 在 index.html 中CDN引入的方式
 */
registerDep('vue', () => Vue)
registerDep('vuex', () => Vuex)
registerDep('vue-router', () => VueRouter)
registerDep('axios', () => axios)
// registerDep('element-ui', () => ELEMENT)

function registerDep(name, requirer) {
  SystemJS.registerDynamic(name, [], false, function(_r, _e, _m) {
    _m.exports = requirer()
  })
}